/* istanbul ignore file */
export * from './entitle';
